import { INTL_CURRENCIES, INTL_CURRENCY_LABEL, type IntlCurrency } from "@/lib/intlPricing";
import { useIntlCurrency } from "@/contexts/IntlCurrencyContext";

export default function IntlCurrencySelector({ compact = false }: { compact?: boolean }) {
  const { currency, setCurrency } = useIntlCurrency();

  return (
    <label className="inline-flex items-center gap-2 text-sm text-ink/65">
      {!compact && <span>Currency</span>}
      <select
        aria-label="Currency"
        value={currency}
        onChange={(event) => setCurrency(event.target.value as IntlCurrency)}
        className={compact
          ? "h-9 rounded-full border border-ink/15 bg-cream px-2 text-xs font-semibold text-ink focus:outline-none focus:ring-2 focus:ring-terracotta/30"
          : "rounded-full border border-ink/15 bg-white/60 px-3 py-2 text-sm text-ink focus:outline-none focus:ring-2 focus:ring-terracotta/30"}
      >
        {INTL_CURRENCIES.map((option) => (
          <option key={option} value={option}>
            {INTL_CURRENCY_LABEL[option]}
          </option>
        ))}
      </select>
    </label>
  );
}
